import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import { validateArrayIncludes } from "../../common/validators";
// REDUX
import { setShowResetCountModal } from "../../store/actions/ordersSlice";
import { setShowDriversListModal } from "../../store/actions/driversSlice";
// MATERIAL UI
import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialAction from "@mui/material/SpeedDialAction";
import SpeedDialIcon from "@mui/material/SpeedDialIcon";
import { Fab } from "@mui/material";
// ICONS
import TimerIcon from "@mui/icons-material/Timer";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import SportsMotorsportsIcon from "@mui/icons-material/SportsMotorsports";
// COMPONENTS
import IFoodWidget from "../widgets/IFoodWidget";
import ChatIcon from "@mui/icons-material/Chat";

export default function FloatingMenu() {
  const history = useHistory();
  const dispatch = useDispatch();
  const theme = useTheme();
  const widgetTriggerRef = useRef(null);

  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const alignment = useSelector((state) => state.dashboard.alignment);
  const showDriversListModal = useSelector(
    (state) => state.drivers.showDriversListModal
  );
  const showResetCountModal = useSelector(
    (state) => state.orders.showResetCountModal
  );
  const merchantIfoodIds = useSelector(
    (state) => state.merchants.merchantIfoodIds
  );

  const isRestrictedAlignment = validateArrayIncludes(
    ["packing", "saloon"],
    alignment
  );

  const handleShowDriversListModal = () => {
    const newState = !showDriversListModal;
    dispatch(setShowDriversListModal(newState));
  };

  const handleShowResetCountModal = () => {
    const newState = !showResetCountModal;
    dispatch(setShowResetCountModal(newState));
  };

  const handleShowNewOrderModal = () => {
    const newOrderPath = "/pedido/novo";
    history.push(newOrderPath);
  };

  const handleToggleIfoodWidget = () => {
    // Try multiple methods to trigger the widget
    const triggerButton = document.getElementById("ifood-widget-trigger");

    if (triggerButton) {
      triggerButton.click();
      return;
    }

    // Fallback to global function if available
    if (window.toggleIfoodWidget) {
      window.toggleIfoodWidget();
      return;
    }

    console.warn("iFood widget trigger not found");
  };

  const getSortedMerchantIds = () => {
    if (!merchantIfoodIds || !Array.isArray(merchantIfoodIds)) {
      return [];
    }

    const sortedIds = [...merchantIfoodIds].sort();
    return sortedIds;
  };

  const renderSpeedDialActions = () => {
    const actions = [];

    if (!isRestrictedAlignment) {
      actions.push({
        key: "Entregadores",
        icon: <SportsMotorsportsIcon />,
        tooltipTitle: "Entregadores",
        onClick: handleShowDriversListModal,
      });

      actions.push({
        key: "Reiniciar-Contagem",
        icon: <TimerIcon />,
        tooltipTitle: "Reiniciar Contagem",
        onClick: handleShowResetCountModal,
      });
    }

    const hasMerchantIds = merchantIfoodIds && merchantIfoodIds.length > 0;
    if (hasMerchantIds) {
      actions.push({
        key: "iFood-Widget",
        icon: <ChatIcon />,
        tooltipTitle: "Chat iFood",
        onClick: handleToggleIfoodWidget,
      });
    }

    const speedDialActions = actions.map((action) => (
      <SpeedDialAction
        key={action.key}
        icon={action.icon}
        tooltipTitle={action.tooltipTitle}
        onClick={action.onClick}
      />
    ));

    return speedDialActions;
  };

  const renderNewOrderButton = () => {
    if (isRestrictedAlignment) {
      return null;
    }

    const buttonStyles = {
      position: "absolute",
      bottom: isMobile ? 55 : 25,
      left: 90,
    };

    const newOrderButton = (
      <Fab
        className="new-order-step"
        variant="extended"
        color="primary"
        onClick={handleShowNewOrderModal}
        sx={buttonStyles}
      >
        <MenuBookIcon sx={{ mr: 1 }} />
        Novo Pedido
      </Fab>
    );

    return newOrderButton;
  };

  const renderIfoodWidget = () => {
    const sortedMerchantIds = getSortedMerchantIds();

    if (!sortedMerchantIds || sortedMerchantIds.length === 0) {
      return null;
    }

    const widget = (
      <IFoodWidget merchantIds={sortedMerchantIds} ref={widgetTriggerRef} />
    );

    return widget;
  };

  if (isRestrictedAlignment) {
    return null;
  }

  const speedDialStyles = {
    position: "absolute",
    bottom: isMobile ? 50 : 20,
    left: 16,
  };

  return (
    <>
      <SpeedDial
        ariaLabel="Opções do dashboard"
        sx={speedDialStyles}
        icon={<SpeedDialIcon />}
      >
        {renderSpeedDialActions()}
      </SpeedDial>

      {renderNewOrderButton()}
      {renderIfoodWidget()}
    </>
  );
}
